import { FilterParams } from "interfaces/filters";
import { PaginationParams } from "interfaces/pagination";
import {
  IResponseGetVehicles,
  IHubVehicle,
  IHubVehicleType,
  IHubVehicleBrandModel,
  IHubVehicleModel,
  IHubVehicleBrand,
  IVehicleCarrier,
  IVehicleCarrierPayload
} from "interfaces/Hub";
import { applyQueryString } from "lib/queryString";
import { apiHub, formDataBuilder } from "services";
import type { VehicleDoc, VehicleDocPayload } from "interfaces/vehicle-doc";

export function useHubVehicle() {
  const getListVehicles = async (
    filters: FilterParams,
    pagination: PaginationParams
  ): Promise<any> => {
    const url = applyQueryString(`/vehicle`, {
      ...filters,
      ...pagination,
    });
    const { data } = await apiHub.get<IResponseGetVehicles>(url);
    return data;
  };

  const getListVehicleDocs = async (
    filters: FilterParams
  ): Promise<VehicleDoc[]> => {
    const url = applyQueryString(`/vehicle-docs`, {
      ...filters,
    });
    const { data } = await apiHub.get<VehicleDoc[]>(url);
    return data;
  };

  const addVehicleDoc = async (payload: VehicleDocPayload) => {
    const dataBuilder = formDataBuilder(payload);

    const { data } = await apiHub.post<VehicleDoc[]>(
      `/vehicle-docs`,
      dataBuilder
    );
    return data;
  };

  const removeVehicleDoc = async (vehicleDocId: number) => {
    const { data } = await apiHub.delete<VehicleDoc[]>(
      `/vehicle-docs/${vehicleDocId}`
    );
    return data;
  };

  const getListVehicleCarrier = async (
    filters: FilterParams
  ): Promise<IVehicleCarrier[]> => {
    const url = applyQueryString(`/vehicle-carrier`, {
      ...filters,
    });
    const { data } = await apiHub.get<IVehicleCarrier[]>(url);
    return data;
  };

  const addVehicleCarrier = async (payload: IVehicleCarrierPayload) => {
    const dataBuilder = formDataBuilder(payload);

    const { data } = await apiHub.post<IVehicleCarrierPayload[]>(
      `/vehicle-carrier`,
      dataBuilder
    );
    return data;
  };

  const removeVehicleCarrier = async (vehicleCarrierId: number) => {
    const { data } = await apiHub.delete<IVehicleCarrier[]>(
      `/vehicle-carrier/${vehicleCarrierId}`
    );
    return data;
  };

  const createVehicle = async (data: Partial<IHubVehicle>): Promise<void> => {
    await apiHub.post("/vehicle", data);
  };

  const updateVehicle = async (data: Partial<IHubVehicle>): Promise<void> => {
    await apiHub.put(`/vehicle/${data.id}`, data);
  };

  const deleteVehicle = async (id: number): Promise<void> => {
    await apiHub.delete(`/vehicle/${id}`);
  };

  const getVehicle = async (id: string): Promise<IHubVehicle> => {
    const { data } = await apiHub.get(`/vehicle/${id}`);
    return data;
  };

  //   relacionados

  const listVehicleType = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-types`, filter);
    const { data } = await apiHub.get<IHubVehicleType[]>(url);

    const comboOptions = data.map((el: IHubVehicleType) => ({
      value: el.id,
      name: el.name,
    }));

    return comboOptions;
  };
  const listVehicleSubtype = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-subtypes`, filter);
    const { data } = await apiHub.get<IHubVehicleType[]>(url);

    const comboOptions = data.map((el: IHubVehicleType) => ({
      value: el.id,
      name: el.name,
    }));

    return comboOptions;
  };

  const listVehicleBrand = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-brand-model`, filter);
    const { data } = await apiHub.get<IHubVehicleBrandModel[]>(url);

    // Filtra marcas únicas pelo vehicle_brand_id
    const uniqueBrandsMap = new Map<number, IHubVehicleBrandModel>();
    data.forEach((el: IHubVehicleBrandModel) => {
      if (!uniqueBrandsMap.has(el.vehicle_brand_id)) {
        uniqueBrandsMap.set(el.vehicle_brand_id, el);
      }
    });

    const comboOptions = Array.from(uniqueBrandsMap.values()).map(
      (el: IHubVehicleBrandModel) => ({
        value: el.vehicle_brand_id,
        name: el.brand.name,
      })
    );

    return comboOptions;
  };

  const listBrand = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-brands`, filter);
    const { data } = await apiHub.get<IHubVehicleBrand[]>(url);

    const comboOptions = data.map((el: IHubVehicleBrand) => ({
      value: el.id,
      name: el.name,
    }));

    return comboOptions;
  };

  const listVehicleModel = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-brand-model`, filter);
    const { data } = await apiHub.get<IHubVehicleBrandModel[]>(url);

    const comboOptions = data.map((el: IHubVehicleBrandModel) => ({
      value: el.vehicle_model_id,
      name: el.model.name,
    }));

    return comboOptions;
  };

  const listModel = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-models`, filter);
    const { data } = await apiHub.get<IHubVehicleModel[]>(url);

    const comboOptions = data.map((el: IHubVehicleModel) => ({
      value: el.id,
      name: el.name,
    }));

    return comboOptions;
  };

  return {
    getListVehicles,
    getListVehicleDocs,
    addVehicleDoc,
    removeVehicleDoc,
    createVehicle,
    updateVehicle,
    deleteVehicle,
    getVehicle,
    listVehicleType,
    listVehicleBrand,
    listVehicleModel,
    listBrand,
    listModel,
    getListVehicleCarrier,
    addVehicleCarrier,
    removeVehicleCarrier,
	listVehicleSubtype
  };
}
